exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rich-text[data-v-7566ee86]{min-height:200px;max-width:960px}.rich-text[data-v-7566ee86] .ck-editor__editable{min-height:420px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7566ee86","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/rich-text-page.vue
// module id = 580
// module chunks = 0